import { Icon } from "@iconify/react";
import React from "react";
import { Link } from "react-router-dom";

import TemplateImg from "../../../assets/images/no-template.svg";
const NoTemplateAdded = ({ selected, content, addNew, onAdd }) => {
  return (
    <div className="no-template">
      <img src={TemplateImg} alt="" />
      <h4>{selected}</h4>
      <p>{content}</p>
      <Link to="#" className="btn cta-primary-light mt-4" onClick={onAdd}>
        {" "}
        {addNew}
        <i className="ms-2">
          <Icon icon="ant-design:plus-outlined" />
        </i>
      </Link>
    </div>
  );
};

export default NoTemplateAdded;
